export enum JsonArrayComponentOption {
    GridView = 'gridview',
    CodeMirror = 'codemirror'
}
